import VideosIndex from './VideosIndex';
import VideosCreate from './VideosCreate';
import VideosSettings from './VideosSettings';
import VideosSingle from './VideosSingle';

export default function (app) {

    const settings = VideosSettings;

    app.addModel({
        name: settings.key,
        path: settings.path,
        modelName: settings.modelName,
        endpoint: settings.endpoint,
        idKey: settings.idKey,
        primaryKey: settings.primaryKey,
    });

    app.addMenu({
        key: settings.key,
        zone: settings.zone,
        label: settings.title,
        priority: 14,
        items: [
            {
                label: "All",
                path: settings.path,
                caps: settings.indexCaps
            },
            {
                label: "Add New",
                path: settings.path + "/create",
                caps: settings.createCaps
            }
        ],
    });

    VideosIndex(app, settings);

    VideosCreate(app, settings);

    VideosSingle(app, settings);

}